import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './configurazioni/guard/keycloak.guard';


const routes: Routes = [
  { path: '', loadComponent: () => import('./shared/pages/dashboard/dashboard.component').then(m => m.default),canActivate:[AuthGuard ] },
  { path: 'pazienti', loadComponent: () => import('./components/page/pazienti/pazienti.component').then(m => m.PazientiComponent),canActivate:[AuthGuard ] },
  { path: 'crea-paziente', loadComponent: () => import('./components/pazienti/crea-nuovo-paziente/crea-nuovo-paziente.component').then(m => m.CreaNuovoPazienteComponent),canActivate:[AuthGuard ] },
  { path: 'farmaco-genetica', loadComponent: () => import('./components/farmaco-genetic-links/farmaco-genetic-links.component').then(m => m.FarmacoGeneticLinksComponent),canActivate:[AuthGuard ] },
  {
    path: 'paziente/:codiceFiscale',
    loadComponent: () => import('./components/pazienti/profilo-paziente/profilo-paziente.component')
      .then(m => m.ProfiloPazienteComponent),
    canActivate: [AuthGuard] 
  },
  {
    path: 'richiesta-sequenziamento/:codiceFiscale',
    loadComponent: () => import('./components/better/richiesta-sequenziamento/richiesta-sequenziamento.component')
      .then(m => m.RichiestaSequenziamentoComponent),
    canActivate: [AuthGuard] 
  },
  {
    path: 'lista-richieste-sequenziamento',
    loadComponent: () => import('./components/page/lista-richieste-sequenziamento/lista-richieste-sequenziamento.component')
      .then(m => m.ListaRichiesteSequenziamentoComponent),
    canActivate: [AuthGuard] 
  },
  {
    path: 'lista-risultati-sequenziamento',
    loadComponent: () => import('./components/page/lista-risultati-sequenziamento/lista-risultati-sequenziamento.component')
      .then(m => m.ListaRisultatiSequenziamentoComponent),
    canActivate: [AuthGuard] 
  },
  {
    path: 'sequenziamento/:codiceFiscale',
    loadComponent: () => import('./components/better/sequenziamento/sequenziamento.component')
      .then(m => m.SequenziamentoComponent),
    canActivate: [AuthGuard] 
  },
  {
    path: 'analisi-cariotipo',
    loadComponent: () => import('./components/better/analisi-cariotipo/analisi-cariotipo.component')
      .then(m => m.AnalisiCariotipoComponent),
    canActivate: [AuthGuard] 
  },
  {
    path: 'richiesta-cariotipo/:codiceFiscale',
    loadComponent: () => import('./components/better/richiesta-cariotipo/richiesta-cariotipo.component')
      .then(m => m.RichiestaCariotipoComponent),
    canActivate: [AuthGuard] 
  },
  {
    path: 'lista-geni',
    loadComponent: () => import('./components/gene/lista/lista.component')
      .then(m => m.ListaComponent),
    canActivate: [AuthGuard] 
  },
  {
    path: 'principi-attivi',
    loadComponent: () => import('./components/principiAttivi/lista/lista.component')
      .then(m => m.ListaComponent),
    canActivate: [AuthGuard]
  }, {
    path: 'resoconto-gene/:nome',
    loadComponent: () => import('./components/page/resoconto-gene/resoconto-gene.component')
      .then(m => m.ResocontoGeneComponent),
    canActivate: [AuthGuard] 
  }, {
    path: 'processi',
    loadComponent: () => import('./components/page/processi/processi.component')
      .then(m => m.ProcessiComponent),
    canActivate: [AuthGuard] 
  },{
    path: 'sequenziamento',
    loadComponent: () => import('./page/processo-form/processo-form.component')
      .then(m => m.ProcessoFormComponent),
    canActivate: [AuthGuard] 
  },{
    path: 'cariotipo',
    loadComponent: () => import('./components/page/cariotipo/cariotipo.component')
      .then(m => m.CariotipoComponent),
    canActivate: [AuthGuard] 
  }, {
    path: 'resoconto-farmaco/:nome',
    loadComponent: () => import('./shared/components/farmaco-info/farmaco-info.component')
      .then(m => m.FarmacoInfoComponent),
    canActivate: [AuthGuard] 
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
